export default "__VITE_ASSET__BXDatOK$__"